<template lang="pug">
.container.grid-xl.py-2
  h5.h5
    i.fa.fa-book.fa-fw
    |  Manuais
  p.text-gray Manuais de uso do OS-m Admin. Selecione um tópico para ler.

  .manual-sections
    .manual-section(v-for="group in manuais" :key="group.section")
      button.manual-section-toggle(
        type="button"
        :aria-expanded="isOpen(group.section) ? 'true' : 'false'"
        @click="toggle(group.section)"
      )
        i.fa.fa-fw.manual-section-chevron(
          :class="isOpen(group.section) ? 'fa-chevron-down' : 'fa-chevron-right'"
        )
        span.manual-section-title {{ group.section }}
        span.manual-section-count.text-gray ({{ group.items.length }})
      .manual-list(v-show="isOpen(group.section)")
        router-link.manual-item.tile.tile-centered(
          v-for="item in group.items"
          :key="item.slug"
          :to="{ name: item.routeName }"
        )
          .tile-icon
            i.fa.fa-file-text-o.fa-2x.text-primary
          .tile-content
            .tile-title {{ item.title }}
            .tile-subtitle {{ item.description }}
          .tile-action
            i.fa.fa-angle-right.fa-lg
</template>

<script>
import manuais from "@/lib/manuais/catalog"

export default {
  data() {
    return {
      manuais,
      openSections: [],
    }
  },
  methods: {
    isOpen(section) {
      return this.openSections.indexOf(section) !== -1
    },
    toggle(section) {
      const idx = this.openSections.indexOf(section)
      if (idx === -1) {
        this.openSections.push(section)
      } else {
        this.openSections.splice(idx, 1)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.manual-sections
  margin-top 1rem

.manual-section
  margin-bottom 0.75rem
  border 1px solid #e7e9ed
  border-radius 4px
  background #fff
  overflow hidden

.manual-section-toggle
  display flex
  align-items center
  width 100%
  margin 0
  padding 0.75rem 1rem
  border 0
  background #f8f9fa
  cursor pointer
  text-align left
  color #5755d9
  font-weight 700
  font-size 0.9rem
  line-height 1.2

  &:hover
    background #f1f3f5

  &:focus
    outline none
    box-shadow inset 0 0 0 2px rgba(87, 85, 217, 0.25)

.manual-section-chevron
  margin-right 0.5rem
  width 1em

.manual-section-title
  flex 1
  text-transform none

.manual-section-count
  font-weight 400
  font-size 0.85rem
  margin-left 0.5rem

.manual-list
  padding 0.5rem 0.75rem 0.75rem

.manual-item
  display flex
  align-items center
  padding 0.75rem 1rem
  margin-bottom 0.5rem
  border 1px solid #e7e9ed
  border-radius 4px
  color inherit
  text-decoration none
  background #fff

  &:last-child
    margin-bottom 0

  &:hover
    background #f8f9fa
    border-color #d0d5dd
    color inherit

  .tile-icon
    margin-right 1rem

  .tile-content
    flex 1

  .tile-title
    font-weight 600

  .tile-subtitle
    color #727e96
    font-size 0.85rem
</style>
